export default "__VITE_ASSET__BLqwyxq0__"